export default __webpack_public_path__ + "static/media/endettement.6e168e56.svg";